import { useSelector } from "react-redux";

function AI() {
  const { aiItems } = useSelector((state) => state.portfolio);

  return (
    <section className="mx-auto min-h-[calc(100vh-96px)] max-w-7xl px-5 py-4">
      <h1 className="text-4xl font-bold text-white">AI</h1>
      <p className="mt-3 max-w-2xl text-slate-400">
        AI experiments, automation ideas, assistant UI concepts, and tools.
      </p>

      <div className="mt-10 grid gap-5 md:grid-cols-2">
        {aiItems.map((item) => (
          <div
            key={item.title}
            className="rounded-3xl border border-white/10 bg-white/5 p-6"
          >
            <h2 className="text-xl font-semibold">{item.title}</h2>
            <p className="mt-2 text-slate-400">{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default AI;